export default __webpack_public_path__ + "static/media/ak.ae409038.png";